/**
 * Keep Shopify's required variant input in sync with the visible variant picker.
 * Some product-option app builds remove the hidden input value after the theme
 * has rendered. Running in the capture phase restores it before any app reads
 * or submits the product form.
 */
(function () {
  function selectedVariantId(scope) {
    var root = scope && scope.closest ? scope.closest('.shopify-section') : null;
    var picker = (root || document).querySelector('variant-picker');
    var checked = picker && picker.querySelector('input:checked[data-variant-id]');

    if (checked && checked.dataset.variantId) return checked.dataset.variantId;

    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlVariant) return urlVariant;

    var json = picker && picker.querySelector('script[type="application/json"]');
    if (json) {
      try {
        var variant = JSON.parse(json.textContent || '{}');
        if (variant && variant.id) return String(variant.id);
      } catch (error) {
        // Invalid app data should not block the normal product form.
      }
    }

    return '';
  }

  function syncVariant(source) {
    var id = selectedVariantId(source);
    if (!id) return;

    var section = source && source.closest ? source.closest('.shopify-section') : null;
    var inputs = (section || document).querySelectorAll('form[action*="/cart/add"] input[name="id"]');

    inputs.forEach(function (input) {
      if (input.value !== id) input.value = id;
      if (input.getAttribute('value') !== id) input.setAttribute('value', id);
    });
  }

  function syncFromEvent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (
      target.closest('variant-picker') ||
      target.closest('form[action*="/cart/add"]') ||
      target.closest('button[name="add"], add-to-cart-component')
    ) {
      syncVariant(target);
    }
  }

  function unifyGiftWrapping() {
    if (!document.querySelector('.hilbert-gift-wrap')) return false;

    var giftOptionFound = false;

    document.querySelectorAll('.bss-po-product-page .po-stack').forEach(function (stack) {
      var heading = stack.querySelector('.po-label-container');
      var label = heading ? heading.textContent.trim().toLowerCase() : '';

      if (label === 'gift wrapping' || label === 'gaveindpakning') {
        giftOptionFound = true;
        var isEnglish = document.documentElement.lang.toLowerCase().indexOf('en') === 0;
        var customGift = document.querySelector('.hilbert-gift-wrap');
        var headingText = heading.querySelector('span');
        var valueText = stack.querySelector('.po_option_value');
        var translatedHeading = isEnglish ? 'GIFT WRAPPING' : 'GAVEINDPAKNING';
        var translatedValue = isEnglish ? 'Yes' : 'Ja';

        if (!customGift.hidden) customGift.hidden = true;
        if (customGift.getAttribute('aria-hidden') !== 'true') customGift.setAttribute('aria-hidden', 'true');
        if (customGift.style.display !== 'none') customGift.style.setProperty('display', 'none', 'important');
        if (stack.hidden) stack.hidden = false;
        if (stack.hasAttribute('aria-hidden')) stack.removeAttribute('aria-hidden');
        if (stack.style.display !== 'flex') stack.style.setProperty('display', 'flex', 'important');
        if (headingText && headingText.textContent !== translatedHeading) headingText.textContent = translatedHeading;
        if (valueText && valueText.textContent !== translatedValue) valueText.textContent = translatedValue;
      }
    });

    return giftOptionFound;
  }

  ['pointerdown', 'mousedown', 'touchstart', 'click', 'submit'].forEach(function (eventName) {
    window.addEventListener(eventName, syncFromEvent, true);
  });

  window.addEventListener(
    'change',
    function (event) {
      syncFromEvent(event);
      window.setTimeout(function () {
        syncFromEvent(event);
      }, 0);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    syncVariant(document.body);
    var giftOptionReady = unifyGiftWrapping();
    window.setTimeout(function () {
      syncVariant(document.body);
      unifyGiftWrapping();
    }, 250);
    window.setTimeout(function () {
      syncVariant(document.body);
      unifyGiftWrapping();
    }, 1000);
    window.setTimeout(unifyGiftWrapping, 2000);

    // Optis is loaded asynchronously and can appear after the fixed timeouts.
    // Watch only for inserted nodes, then merge its gift option with Hilbert's
    // native option while leaving future paid chain options untouched.
    if (giftOptionReady) return;

    var giftObserver = new MutationObserver(function (mutations) {
      var hasInsertedNodes = mutations.some(function (mutation) {
        return mutation.addedNodes && mutation.addedNodes.length > 0;
      });

      if (hasInsertedNodes && unifyGiftWrapping()) giftObserver.disconnect();
    });

    giftObserver.observe(document.body, { childList: true, subtree: true });
  });
})();
